import { useAuth } from "@de/ist-cloud-auth";
import { watchOnce } from "@vueuse/core";
import { acceptHMRUpdate, defineStore } from "pinia";
import { ref } from "vue";

import { type UISettings } from "@/api/generated/model";
import { getUiOptions } from "@/service/Api";

export const useUiStore = defineStore("UI", () => {
	// "https://organisation.ist-connect.de"; //"https://ist-manager.de"; //"https://dev.ist-manager.de";
	const { customerId } = useAuth();

	const options = ref<UISettings>();

	watchOnce(customerId, () => {
		getUiOptions().then((data) => {
			options.value = data;
		});
	});

	return {
		options,
	};
});

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useUiStore, import.meta.hot));
}
